import { v4 as uuidV4 } from 'uuid';

import { ProtocolFactory } from 'lib/protocols';

import { EPropType } from '@types';

import { TextareaProps } from './index';

export const protocolFactory = new ProtocolFactory<TextareaProps>({
  name: 'Textarea',
  editorProps: [
    {
      type: EPropType.String,
      name: 'name',
      required: true,
      label: 'Name',
      description: 'Name of the textarea',
      defaultValue: uuidV4(),
    },
    {
      type: EPropType.String,
      name: 'label',
      required: true,
      label: 'Label',
      description: 'The label of the textarea inside of the form control',
      defaultValue: 'Example',
    },
    {
      type: EPropType.String,
      name: 'resize',
      required: true,
      label: 'Resize',
      description: 'Textarea resize behavior',
      defaultValue: 'vertical',
      values: ['vertical', 'horizontal', 'none'],
    },
    {
      type: EPropType.String,
      name: 'placeholder',
      required: true,
      label: 'Placeholder',
      description: 'Text inside the textarea if no value is provided',
      defaultValue: 'Insert some text here',
    },
  ],
  themeProps: ['size'],
});

export const defaultProps = protocolFactory.createDefaultProps();
